const clearNotification = notification => {
  const currentNotification = notification || document.querySelector('.mdm-notification');

  if (currentNotification && currentNotification.parentNode) {
    currentNotification.parentNode.removeChild(currentNotification);
  }
};

const TIMER = 5000;
const SLOW_TIMER = 2000;

const showNotification = options => {
  clearNotification();
  const notification = document.createElement('div');
  notification.className = 'mdm-notification';
  notification.style.background = options.backgroundColor;
  notification.style.color = 'white';
  notification.style.position = 'fixed';
  notification.style.top = 0;
  notification.style.left = 0;
  notification.style.width = '100%';
  notification.style.padding = '12px';
  notification.style['z-index'] = 99999;
  notification.style.opacity = 1;
  notification.style.animation = 'updown 0.5s';
  notification.style.transition = 'all 1s ease-in-out';
  notification.innerHTML = "<u>".concat(options.text, "<u>");

  const notificationClicked = () => {
    window.location = options.destination;
  };

  notification.addEventListener('click', notificationClicked, true);
  document.body.insertBefore(notification, document.body.firstChild);

  if (notification) {
    window.setTimeout(() => {
      notification.style.opacity = 0;
      notification.removeEventListener('click', notificationClicked, true);
      window.setTimeout(() => {
        clearNotification(notification);
      }, SLOW_TIMER);
    }, TIMER);
  }
};

export default showNotification;